let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '馈网流水号',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '设备编码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '开始馈网时间',
        props: 'orderNo',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '结束馈网时间',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '累计放电量',
        props: 'sourceName',
        minWidth: 200,
    },
    {
        label: '平均功率',
        props: 'chargeStepName',
        minWidth: 200,
    },
];

// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '馈网放电服务'
    }
];

// 列表-表格属性
pageConfig.tableConfigList = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.paginationList = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

export default pageConfig;
